import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      path: '/',
      icon: '📊',
      label: 'Dashboard',
      exact: true
    },
    {
      path: '/analytics',
      icon: '📈',
      label: 'Analytics'
    },
    {
      path: '/consultores',
      icon: '👥',
      label: 'Consultores'
    },
    {
      path: '/whatsapp',
      icon: '💬',
      label: 'WhatsApp'
    }
  ];

  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className={`${isCollapsed ? 'w-20' : 'w-64'} bg-gray-900 min-h-screen flex flex-col transition-all duration-300 fixed left-0 top-0 z-50`}>
      {/* Logo */}
      <div className="flex items-center justify-center p-6 border-b border-gray-800">
        <img
          src="/exime.png"
          alt="Exime Logo"
          className={`${isCollapsed ? 'w-10 h-10' : 'h-12'} object-contain transition-all duration-300`}
        />
      </div>

      {/* Menu Items */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
              isActive(item.path, item.exact)
                ? 'bg-blue-600 text-white shadow-lg'
                : 'text-gray-300 hover:bg-gray-800 hover:text-white'
            }`}
            title={isCollapsed ? item.label : ''}
          >
            <span className="text-xl">{item.icon}</span>
            {!isCollapsed && (
              <span className="ml-3 font-medium">{item.label}</span>
            )}
          </Link>
        ))}
      </nav>

      {/* User Info & Logout */}
      <div className="border-t border-gray-800 p-4">
        {!isCollapsed && (
          <div className="mb-4 px-4">
            <p className="text-sm text-gray-400">Logado como</p>
            <p className="text-white font-medium truncate">{user?.name}</p>
            <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
          </div>
        )}

        <button
          onClick={logout}
          className="flex items-center w-full px-4 py-3 rounded-lg text-gray-300 hover:bg-red-600 hover:text-white transition-all duration-200"
          title="Sair"
        >
          <span className="text-xl">🚪</span>
          {!isCollapsed && <span className="ml-3 font-medium">Sair</span>}
        </button>

        {/* Collapse Button */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="flex items-center justify-center w-full mt-4 px-4 py-2 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white transition-all duration-200"
          title={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          <span className="text-xl">{isCollapsed ? '→' : '←'}</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
